import { gql } from '@apollo/client'

export const SET_TEST_SESSION_LAB = gql`
  mutation SetTestSessionLab($inputData: SetTestSessionLabInput!) {
    setTestSessionLab(inputData: $inputData)
  }
`
